// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "d56bc6bba88e50f4ee7328803ca7f539a6cca4e8/static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"83cd5b92","98":"c3469f9b","157":"5fa962a7","215":"28b12c6b","515":"941628b2","777":"dfb468f1","952":"a8f7192d"}[chunkId] + ".chunk.js";
};